import { creatorbase } from '@round/api';
import { Image } from '@round/ui-kit';
import styles from './TeamNameCard.module.css';
import cn from 'classnames';

type Props = {
    team: creatorbase.Team | null | undefined;
    client?: creatorbase.Client | null;
};

const TeamNameCard = ({ team, client }: Props) => {
    return (
        <div className={styles.container}>
            <Image
                className={cn(styles.image, styles.teamImage)}
                alt={team?.name ?? ''}
                src={team?.logo_large ?? team?.logo ?? ''}
            />
            <div className={styles.body}>
                <p className={styles.teamName}>{team?.name}</p>
                {client ? (
                    <>
                        <hr className={styles.separator} />
                        <div className={cn(styles.container, styles.client)}>
                            <Image
                                className={cn(styles.image, styles.clientImage)}
                                alt={client?.name ?? ''}
                                src={client?.logo ?? ''}
                            />
                            <p className={styles.clientName}>{client?.name}</p>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default TeamNameCard;
